

  <loader *ngIf="loading"></loader>


    <ui-table
    #tblEntries
    *ngIf="displayClaims"
    [isWrapped]="false"
    [data]="displayClaims"
    [numberOfRows]="rowsPerPage"
    [totalRecords]="totalRecords"
    [showPaginator]="true"
    [checkboxSelection]="true"
    [paginatorPosition]="'bottom'"
    [customCheckboxCellTemplate]="selectRow"
    [customCheckboxHeaderTemplate]="emptySelectAll"
    (requestUpdate)="onPagination($event)"
    [templates]="[
      {
        title: 'translate.general.claims-view.claimId',
        template: claimId
      },
      {
        title: 'translate.general.claims-view.claimText',
        template: mainText
      },
      {
        title: 'translate.general.claims-view.claimContentType',
        template: claimContentType
      },
      {
        title: 'translate.general.claims-view.status',
        template: status
      },
      {
        title: 'translate.general.actions',
        template: actions
      }
      ]"
      [more]="expandRow"
      [topEnd]="filterArea"
    >
  </ui-table>

  <ng-template #filterArea>
    <div class="filter-bar-claims l-align-spaceBetween">
      <div class="filter-container" style="width: auto;">
            <checkbox-wrap
              style="margin-left: 16px;"
              class="checkbox"
              [labelTitle]="'translate.general.selectAll' | translate"
            >
              <input
                type="checkbox"
                [(ngModel)]="selectAll"
                (ngModelChange)="onToggleSelectAll()"
              />
            </checkbox-wrap>
            <!-- p-select with approve and delete actions -->
             <input-wrap 
              class="bulk-actions-dropdown bulk-actions-divider">
              <p-select 
                [options]="actionList"
                [disabled]="selectedClaims.length === 0"
                optionLabel="text"
                [(ngModel)]="selectedActionId"
                optionValue="id"
                optionLabel="text"
                [showClear]="true"
                [placeholder]="'translate.general.actions' | translate"
                (onChange)="onActionSelected($event)"
              ></p-select>
            </input-wrap>
        <input-wrap class="t-input-search-wrap">
          <input
            class="t-input"
            type="text"
            [(ngModel)]="filterText"
            placeholder="{{ 'translate.general.search' | translate }}"
            (keypress)="onFilterKeyPress($event)"
          />
        </input-wrap>

        <input-wrap [loading]="false">
          <p-select
            [options]="contentTypeList"
            optionLabel="label"
            [(ngModel)]="filterClaimType"
            [resetFilterOnHide]="true"
            [filterPlaceholder]="'translate.general.search' | translate"
            [placeholder]="'translate.general.claims-view.claimContentType' | translate"
            [filter]="true"
            [showClear]="true"
            (onChange)="onFieldValueChanged($event)"
          >
          </p-select>
        </input-wrap>

        <input-wrap>
          <p-select
            [options]="claimStatusList"
            optionLabel="label"
            [(ngModel)]="filterStatus"
            [resetFilterOnHide]="true"
            [filterPlaceholder]="'translate.general.search' | translate"
            [placeholder]="'translate.general.statusDescr' | translate"
            [filter]="true"
            [showClear]="true"
            (onChange)="onFieldValueChanged($event)"
          >
          </p-select>
        </input-wrap>

        <a *ngIf="displayClearFilter" (click)="clearFilter()">{{
          "translate.general.clear" | translate
        }}</a>
      </div>
      <div style="margin-left: auto">
          <button class="t-button" (click)="displayClaimForm = true; mode = 'create'; claimFormModel = null; claimFormRefDocs = null">
            {{ "translate.claims-view.addClaim" | translate }}
          </button>
      </div>
    </div>
  </ng-template>

  <ng-container *ngIf="displayClaimForm">
    <claim-form
    [mode]="mode"
    [claim]="claimFormModel"
    [loadedRefDocs]="claimFormRefDocs"
    (onClose)="displayClaimForm = false; claimFormModel = null; claimFormRefDocs = null"
    (refreshView)="displayClaimForm = false; loadEntries(true);"
    [catalog]="this.ngRedux.getState().curCat">

    </claim-form>
  </ng-container>

    <ng-template #claimId let-row="row">
    {{ row.claimId }}
  </ng-template>

  <ng-template #selectRow let-row>
    <div class="t-table-select-row">
      <checkbox-wrap class="checkbox" [stopPropagation]="true" [labelTitle]="'Select'">
        <input type="checkbox" [checked]="isSelected(row)" 
        (click)="$event.stopPropagation()"
        (change)="onChangeSelection(row, $event)" />
      </checkbox-wrap>
    </div>
  </ng-template>
  <!-- because we are displaying select all on different place, not inside table-->
  <ng-template #emptySelectAll>
    <div></div>
  </ng-template>
  <ng-template #claimContentType let-row="row">
    <div class="cat-phrase-type">
      {{ row.phraseContentType }}
    </div>
  </ng-template>
  
  <ng-template #mainText let-row="row">
    <div>
      {{ row.mainText }}
    </div>
  </ng-template>
  <ng-template #status let-row="row">
    <div>
      {{ row.status }}
    </div>
  </ng-template>
    <ng-template #actions let-row="row">
    <div class="actions-row">
      <a
        *ngIf="row.status == 'APPROVED'"
        class="icon"
        (click)="view($event, row)"
        [attr.aria-label]="'translate.general.view' | translate"
      >
        <i
          class="fa-solid fa-eye"
          [tooltip]="'translate.general.view' | translate"
        ></i>
      </a>
      <a *ngIf="row.status != 'APPROVED'" (click)="edit($event, row)">
       <i class="fa-solid fa-pen-to-square" [tooltip]="'translate.general.edit' | translate"></i>
      </a>
      <span class="action-divider">|</span>
      <a
        class="icon"
        (click)="delete($event, row)"
        [attr.aria-label]="'translate.general.delete' | translate"
      >
        <i
          class="fa-solid fa-trash-can"
          [tooltip]="'translate.general.delete' | translate"
        ></i>
      </a>
      <ng-container *ngIf="row.status === 'DRAFT'">
        <span class="action-divider">|</span>
        <a
          class="icon"
          (click)="approve($event, row)"
          [attr.aria-label]="'translate.cat.approve' | translate"
        >
          <i
            class="fa-solid fa-check"
            [tooltip]="'translate.cat.approve' | translate"
          ></i>
        </a>
      </ng-container>
      <ng-container *ngIf="row.status === 'APPROVED'">
        <span class="action-divider">|</span>
        <a
          class="icon"
          (click)="draft($event, row)"
          [attr.aria-label]="'translate.cat.setToDraft' | translate"
        >
          <i
            class="fa-solid fa-arrow-rotate-left"
            [tooltip]="'translate.cat.setToDraft' | translate"
          ></i>
        </a>
      </ng-container>
    </div>
  </ng-template>
    <ng-template #expandRow let-row="row">
    <tabs>
      <!--documents-->
      <tab-single
        tabTitle="{{ 'translate.cat.catDocs' | translate }}"
        [tabId]="tabIdList.CLAIMS__VIEW__DOC"
      >
        <cat-entry-docs
          class="t-small"
          *ngIf="row.docs?.length > 0"
          [docs]="row.docs"
        ></cat-entry-docs>
      </tab-single>

      <!--references-->
      <tab-single
        *ngIf="row.references?.length > 0"
        tabTitle="{{ 'translate.cat.references' | translate }}"
        [tabId]="tabIdList.CLAIMS__VIEW__REF"
      >
        <ui-table
          class="t-small"
          [isWrapped]="false"
          [data]="row.references"
          [displayFilter]="['refPhraseText', 'anchorPath']"
        ></ui-table>
      </tab-single>
      <tab-single
        *ngIf="row.footnotes?.length > 0"
        tabTitle="{{ 'translate.general.claims-view.footnotes' | translate }}"
        [tabId]="tabIdList.CLAIMS__VIEW__FOOTNOTES"
      >
        <ui-table
          class="t-small"
          [isWrapped]="false"
          [data]="row.footnotes"
          [displayFilter]="['footnoteText']"
        ></ui-table>
      </tab-single>
      <!--associated text-->
      <tab-single
        *ngIf="row.associatedText?.length > 0"
        tabTitle="{{ 'translate.general.associatedText' | translate }}"
        [tabId]="tabIdList.CLAIMS__VIEW__ASSOC_TEXT"
      >
        <ui-table
          class="t-small"
          [isWrapped]="false"
          [data]="row.associatedText"
          [displayFilter]="['assocPhraseText']"
        ></ui-table>
      </tab-single>

      <!--metadata-->
      <tab-single
      *ngIf="row.metadata?.length"
        tabTitle="{{ 'translate.general.claims-view.metadata' | translate }}"
        [tabId]="tabIdList.CLAIMS__VIEW__METADATA">

          <ng-container *ngFor="let data of row.metadata">
            <div class="metadata-container">
              <div class="t-small metadata-row">
                <div>
                  {{ data.fieldLabel }}:
                </div>
                <div class="metadata-values">
                  {{ displayValues(data) }}
                </div>
              </div>
            </div>
          </ng-container>
    </tab-single>
    </tabs>
  </ng-template>

<!-- currently not used
  <modal-popup *ngIf="editMetadata"
  [title]="'translate.general.claims-view.edit-metadata'"
  [flexible]="true"
  [cssClass]="'claim-view-edit-metadata-dialog'"
  [isOpen]="editMetadata"
  (onClose)="editMetadata = false"
  >
  <div>
    <loader *ngIf="loadingClaimChanges"></loader>
    <add-doc-metadata [envId]="envId" [catVersionId]="catVersionId"
    [docMetadataHandler]="docMetadataHandler"
    [catSystemVersion]="catSystemVersion" [lang]="lang"
    [entityType]="'CLAIM'">

    </add-doc-metadata>
    <div class="actions">
      <button
        class="t-button-outline"
        (click)="cancelEditMetadata()"
      >
        {{ "translate.general.cancel" | translate }}
      </button>
      &nbsp;
      <button
        class="t-button"
        [disabled]="!enableSaveMetadataChanges"
        (click)="saveMetadataChanges()"
      >
        {{ "translate.general.ok" | translate }}
      </button>
    </div>
    </div>
  </modal-popup>
-->
  <modal-popup *ngIf="bulkEditMetadata"
    [title]="'translate.general.claims-view.bulk-edit-metadata'"
  [flexible]="true"
  [cssClass]="'claim-view-edit-metadata-dialog'"
  [isOpen]="bulkEditMetadata"
  (onClose)="cancelEditBulkMetadata()">
      <loader *ngIf="loadingClaimChanges"></loader>
    <claim-bulk-metadata [envId]="envId" [catVersionId]="catVersionId"
    [docMetadataHandler]="docMetadataHandler"
    [catSystemVersion]="catSystemVersion" [lang]="lang"
    [selectedClaims]="selectedClaims"
    #bulkClaimMetadata
    [entityType]="'CLAIM'">
    </claim-bulk-metadata>
    <div class="actions">
      <button
        class="t-button-outline"
        (click)="cancelEditBulkMetadata()"
      >
        {{ "translate.general.cancel" | translate }}
      </button>
      &nbsp;
      <button
        class="t-button"
        [disabled]="!enableBulkMetadataChanges"
        (click)="saveBulkMetadataChanges()"
      >
        {{ "translate.general.ok" | translate }}
      </button>
    </div>
  </modal-popup>